import { Suspense, useEffect } from 'react'
import './App.css'
import '/node_modules/bootstrap/dist/js/bootstrap.js'
import '/node_modules/bootstrap/dist/css/bootstrap.css'
import './assets/styles/assets/Assets.css'
import './assets/styles/assets/Dashboard.css'
import './assets/styles/header/Header.css'
import './assets/styles/user_login/UserLogin.css'
import './assets/styles/data_table_actions/Action.css'
import './assets/styles/main/Main.css'
import 'react-toastify/dist/ReactToastify.css'
import 'aos/dist/aos.css'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "../src/i18n/i18n"
import { useLocation, useRoutes } from 'react-router-dom'
import Routes from './routes/Route'
import FallbackPage from './routes/auth/FallbackPage'
import { ToastContainer } from 'react-toastify'

function App() {

  const { pathname } = useLocation()

  function RouteLayout({ path }) {
    const element = useRoutes(path);
    return element;
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="App">

      <Suspense fallback={<FallbackPage />}>
        <RouteLayout path={Routes()} />
      </Suspense>

      <ToastContainer />

    </div>
  );
}

export default App;
